// Função para gerar grade com palavras em posições aleatórias (otimizada para mobile - 12x9)
function generateGrid(words, gridRows = 12, gridCols = 9) {
  let grid = Array.from({ length: gridRows }, () =>
    Array.from({ length: gridCols }, () => "")
  );

  const directions = [
    [0, 1],   // direita (horizontal)
    [1, 0],   // baixo (vertical)
  ];

  function canPlaceWord(word, row, col, dir) {
    const [dr, dc] = dir;
    if (
      row + dr * (word.length - 1) >= gridRows ||
      col + dc * (word.length - 1) >= gridCols
    ) {
      return false;
    }
    for (let i = 0; i < word.length; i++) {
      const r = row + dr * i;
      const c = col + dc * i;
      if (grid[r][c] !== "" && grid[r][c] !== word[i]) {
        return false;
      }
    }
    return true;
  }

  function placeWord(word) {
    word = word.toUpperCase();
    let placed = false;
    let attempts = 0;
    while (!placed && attempts < 100) {
      const dir = directions[Math.floor(Math.random() * directions.length)];
      const row = Math.floor(Math.random() * gridRows);
      const col = Math.floor(Math.random() * gridCols);

      if (canPlaceWord(word, row, col, dir)) {
        for (let i = 0; i < word.length; i++) {
          grid[row + dir[0] * i][col + dir[1] * i] = word[i];
        }
        placed = true;
      }
      attempts++;
    }
  }

  words.forEach((word) => placeWord(word));

  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  for (let r = 0; r < gridRows; r++) {
    for (let c = 0; c < gridCols; c++) {
      if (grid[r][c] === "") {
        grid[r][c] = alphabet[Math.floor(Math.random() * alphabet.length)];
      }
    }
  }

  return grid;
}

export default generateGrid;
